// ============================================================================
// beverageFilter — bebida NÃO é venda de produto do profissional
// ============================================================================
// Espelho do filtro isBeverage do scripts/avec-daily-sync.mjs (12/08/2026).
// O sync grava produtosVendidos/faturamentoProdutos SEM bebidas; o agregado ao
// vivo por profissional precisa da MESMA régua, senão o "você fez hoje" da
// meta de performance soma a cerveja que o acumulado oficial nunca vai ter.
// Se mudar aqui, mudar lá (e vice-versa).
// ============================================================================

const EXCL_CATS = ['cerveja', 'bebida sem álcool', 'bebida alcolica', 'bebida alcólica', 'destilada', 'material operação'];
const BEV_KW = ['longneck', 'cerveja', 'beer', 'lata 350', 'energético', 'red bull', 'coca cola', 'guaraná', 'água com gás', 'água sem gás', 'cafe expresso', 'café expresso', 'suco', 'refrigerante', 'chopp', 'gin ', 'whisky', 'vodka', 'drink', 'michelob', 'heineken', 'budweiser', 'corona', 'stella', 'amstel', 'spaten', 'becks'];

export function isBeverageProduct(categoria, nomeProduto) {
  const c = String(categoria || '').toLowerCase().trim();
  if (EXCL_CATS.includes(c)) return true;
  const p = String(nomeProduto || '').toLowerCase();
  return BEV_KW.some(k => p.includes(k));
}
